/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DataComplaintQueryResponse } from './DataComplaintQueryResponse';
import {
    DataComplaintQueryResponseFromJSON,
    DataComplaintQueryResponseFromJSONTyped,
    DataComplaintQueryResponseToJSON,
} from './DataComplaintQueryResponse';

/**
 * 
 * @export
 * @interface FindComplaintQueryResponse
 */
export interface FindComplaintQueryResponse {
    /**
     * 
     * @type {string}
     * @memberof FindComplaintQueryResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FindComplaintQueryResponse
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof FindComplaintQueryResponse
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof FindComplaintQueryResponse
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof FindComplaintQueryResponse
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof FindComplaintQueryResponse
     */
    receivedAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindComplaintQueryResponse
     */
    finishedAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindComplaintQueryResponse
     */
    authorName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindComplaintQueryResponse
     */
    authorEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindComplaintQueryResponse
     */
    authorPhone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindComplaintQueryResponse
     */
    authorRelationship?: string | null;
    /**
     * 
     * @type {DataComplaintQueryResponse}
     * @memberof FindComplaintQueryResponse
     */
    records?: DataComplaintQueryResponse;
}

/**
 * Check if a given object implements the FindComplaintQueryResponse interface.
 */
export function instanceOfFindComplaintQueryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function FindComplaintQueryResponseFromJSON(json: any): FindComplaintQueryResponse {
    return FindComplaintQueryResponseFromJSONTyped(json, false);
}

export function FindComplaintQueryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindComplaintQueryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'receivedAt': !exists(json, 'receivedAt') ? undefined : json['receivedAt'],
        'finishedAt': !exists(json, 'finishedAt') ? undefined : json['finishedAt'],
        'authorName': !exists(json, 'authorName') ? undefined : json['authorName'],
        'authorEmail': !exists(json, 'authorEmail') ? undefined : json['authorEmail'],
        'authorPhone': !exists(json, 'authorPhone') ? undefined : json['authorPhone'],
        'authorRelationship': !exists(json, 'authorRelationship') ? undefined : json['authorRelationship'],
        'records': !exists(json, 'records') ? undefined : DataComplaintQueryResponseFromJSON(json['records']),
    };
}

export function FindComplaintQueryResponseToJSON(value?: FindComplaintQueryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'status': value.status,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'receivedAt': value.receivedAt,
        'finishedAt': value.finishedAt,
        'authorName': value.authorName,
        'authorEmail': value.authorEmail,
        'authorPhone': value.authorPhone,
        'authorRelationship': value.authorRelationship,
        'records': DataComplaintQueryResponseToJSON(value.records),
    };
}

